import type { FC } from "react";

import capitalize from "lodash/capitalize";

import { ChipDownContainer } from "@similarweb/ui-components";

import { i18nFilter } from "app/filters/i18nFilter";
import { getWebsiteTypeItems } from "app/pages/keyword-analysis/Organic";

export interface IWebsiteType {
    id: string;
    text: string;
}

export const INITIAL_WEBSITE_TYPE: IWebsiteType = { id: String(), text: String() };

interface IWebsiteTypeFilter {
    websiteType: string;
    onWebsiteTypeItemClick: (websiteType: IWebsiteType) => void;
    onCloseWebsiteTypeItem: VoidFunction;
    width?: number;
    buttonTextKey?: string;
}

export const WebsiteTypeFilter: FC<IWebsiteTypeFilter> = (props) => {
    const {
        websiteType,
        onWebsiteTypeItemClick,
        onCloseWebsiteTypeItem,
        width = 280,
        buttonTextKey = "analysis.source.search.keywords.filters.websitetype",
    } = props;
    const i18n = i18nFilter();
    // @ts-ignore FIXME: strict migration - Type '"" | { [x: string]: true; }' is not assignable to type '{ [key: string]: boolean; } | undefined' — empty-string fallback preserved for ChipDownContainer external prop
    const selectedIds: { [key: string]: boolean } | undefined = websiteType && { [websiteType]: true };
    return (
        <ChipDownContainer
            width={width}
            hasSearch={false}
            selectedIds={selectedIds}
            selectedText={websiteType && capitalize(websiteType)}
            buttonText={i18n(buttonTextKey)}
            onClick={onWebsiteTypeItemClick}
            onCloseItem={onCloseWebsiteTypeItem}
            noResultsMessage={i18n("dropdown.no.results")}
        >
            {getWebsiteTypeItems()}
        </ChipDownContainer>
    );
};
